import { PaletteOptions } from '@mui/material/styles';
import { bcmeaStyles } from './bcmeaStyles';

const palette: PaletteOptions = {
  primary: {
    main: bcmeaStyles.colour.corporateBlue,
  },
  neutralWhite: bcmeaStyles.colour.neutralWhite,
  black: bcmeaStyles.colour.black,
  clearBlue: bcmeaStyles.colour.clearBlue,
  oceanicGreen: bcmeaStyles.colour.oceanicGreen,
  offGray: bcmeaStyles.colour.offGray,
  coldWhite: bcmeaStyles.colour.coldWhite,
  forestGreen: bcmeaStyles.colour.forestGreen,
  warmBlue: bcmeaStyles.colour.warmBlue,
  corporateBlue: bcmeaStyles.colour.corporateBlue,
  orange: bcmeaStyles.colour.orange,
  boxShadowColor: "rgba(0, 0, 0, 0.25)",
  blue: {
    100: ' #F2F7FC',
    150: '#8FE2FF',
    200: 'rgba(51, 102, 153, 0.2)',
    300: '#CCE2F4',
    400: '#41719C',
    450: '#0075FF',
    500: '#5B9BD5',
    600: '#4071A2',
    650: '#2E75B6',
    700: '#2F5597',
    900: '#236192',
    A100: '#E0EDF8',
    A200: '#DEEBF7',
    A300: '#2E75B6',
    A400: '#C2E0FF',
    A500: '#8bb5ed',
  },
  grey: {
    50: '#707070',
    100: 'rgba(224, 224, 224, 0.8)',
    200: '#BEBDBE',
    300: 'rgba(204, 204, 204, 1)',
    400: '#74899C',
    500: '#F5F5F5',
    600: '#EAEAEA',
    700: 'rgba(234, 234, 234, 0.9)',
    800: '#404040',
    900: '#666666',
    A50: '#E6E6E6',
    A100: 'rgb(191, 191, 191)',
    A150: '#7F7F7F',
    A200: '#595959',
    A250: '#CCCCC0',
    A300: '#CCCCCC',
    A350: '#D9D9D9',
    A400: 'rgb(153, 153, 153)',
    A450: '#f2f2f2',
    A700: '#999999',
  },
  red: {
    200: '#FB5135',
    300: '#ff6666',
    350: '#F8D8DA',
    400: '#FCC3C3',
    500: '#ED1C24',
    550: '#FF3E11',
    600: '#FB4D40',
    650: '#C55A11',
    700: '#d32f2f',
    750: '#FF4500',
    800: '#C00000',
    850: '#841E28',
    900: '#C70000',
    A700: '#FF0000',
  },
  warning: {
    main: '#ed6c02',
    light: '#FFF2AF',
  },
  info: {
    main: '#2F5597',
    light: '#CADDF7',
  },
  success: {
    main: '#ECF5E7',
    light: '#22B14C',
  },
  green: {
    50: '#00B050',
    100: '#CCFF66',
    200: '#CCFFCC',
    300: '#92D050',
    350: '#99FF99',
    400: '#18FF00',
    500: '#319A9C',
    600: '#548235',
    700: '#A9D18E',
    800: '#59873e',
  },
  yellow: {
    50: '#FFFF99',
    100: '#FEFEF4',
    200: '#FAFAD6',
    300: '#FFFF00',
    400: '#FFCC66',
    500: '#FFD966',
    600: '#EEEE92',
  },
};

export default palette;
